var _path, _defs, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScreencastMarketingLogo = props => /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#ScreencastMarketingLogo_svg__a)",
  d: "M28.875 0H3.125A3.125 3.125 0 0 0 0 3.125v25.75C0 30.601 1.4 32 3.125 32h25.75C30.601 32 32 30.6 32 28.875V3.125C32 1.399 30.6 0 28.875 0"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ScreencastMarketingLogo_svg__a",
  x1: 16,
  x2: 16,
  y1: 0,
  y2: 32,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9A731"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EE7B2E"
}))))), /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 24,
  x: 7,
  y: 4,
  fill: "none",
  viewBox: "0 0 18 24"
}, props), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.08 18.444.046 12.407a.03.03 0 0 0-.04.009l-.004.014V23.3a.701.701 0 0 0 1.095.579z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCE2C9",
  d: "M4.015 9.992 0 12.378l9.08 6.066 3.723-2.535z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.695 11.42 1.095.123A.7.7 0 0 0 0 .7v6.637a.03.03 0 0 0 .013.024l12.775 8.534a.03.03 0 0 0 .031 0l4.876-3.32a.7.7 0 0 0 0-1.155"
}))));
export default SvgScreencastMarketingLogo;